<!-- Spacer -->
<div
    class="fakturnia-horizontal-navigation-item-wrapper"
    [ngClass]="item.classes?.wrapper"></div>
